import { type Tag } from '@/lib/types';
import { IconButton } from '@mui/material';
import { DeleteOutlined as DeleteIcon } from '@mui/icons-material';
import { useContext, useState } from 'react';
import useApi from '@/lib/api/useApi';
import TagsContext from '../TagsContext';
import Dialog from '@/components/Dialog';
import { FormattedMessage } from 'react-intl';
import FormattedMessageWithChallengeNaming from '@/components/FormattedMessageWithChallengeNaming';

type DeleteTagProps = {
  tag: Tag;
};

const DeleteTag = ({ tag }: DeleteTagProps) => {
  const api = useApi();
  const [, setTags] = useContext(TagsContext);

  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const deleteTag = async (): Promise<void> => {
    setDeleting(true);

    await api.delete(`editor/tags/${tag.id}`);

    setTags(tags => {
      delete tags[tag.id];
    });

    setDeleting(false);
  };

  return (
    <>
      <IconButton
        size="small"
        color="error"
        onClick={() => setConfirmationDialogOpen(true)}
        disabled={deleting}
      >
        <DeleteIcon fontSize="small" />
      </IconButton>
      <Dialog
        open={confirmationDialogOpen}
        onClose={() => setConfirmationDialogOpen(false)}
        dangerous
      >
        <Dialog.Title>
          <FormattedMessage id="editor.model_editor.field_editor.tags_editor.dialog.tags_manager.tag.delete.dialog.title" />
        </Dialog.Title>
        <Dialog.Content>
          <Dialog.ContentText>
            <FormattedMessageWithChallengeNaming
              id="editor.model_editor.field_editor.tags_editor.dialog.tags_manager.tag.delete.dialog.text"
              hasHtml
            />
          </Dialog.ContentText>
        </Dialog.Content>
        <Dialog.Actions>
          <Dialog.Actions.CancelButton
            onClick={() => setConfirmationDialogOpen(false)}
          />
          <Dialog.Actions.DeleteButton onClick={deleteTag} />
        </Dialog.Actions>
      </Dialog>
    </>
  );
};

export default DeleteTag;
